<div class="absence-conclusion-list container">
  <h1 class="header">{{ 'EAbsenceConclusionsList.AbsenceConlusionsList' | translate }}</h1>

  <div class="content">
    <div #filters class="content-card filters">
      <div class="top">
        <div class="top__right">
          @if (showFilterPresetSelector) {
            <mat-form-field [@inOutAnimation] appearance="outline" class="filter-preset-selector">
              <mat-label>Filtr</mat-label>
              <mat-select [value]="selectedFilterPresetId" (valueChange)="setSelectedFilterPresetId($event)">
                @for (preset of filterPresets; track preset) {
                  <mat-option [value]="preset.Id">{{
                    preset.Name === defaultFilterPresetName ? ('DefaultFilterPresetName' | translate) : preset.Name
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <button (click)="resetFilters()" class="top__button top__button-clear">
            <mat-icon>close</mat-icon>
            {{ 'Reset' | translate }}
          </button>
          <button (click)="toggleFiltersPanel()" class="top__button top__button-filter">
            <mat-icon>filter_alt</mat-icon>
            {{ 'Filter' | translate }}
          </button>
        </div>
      </div>
      @if (areFiltersExpanded) {
        <app-e-absence-conclusions-list-filters [formGroup]="filtersFormGroup" (filterGridData)="filterData($event)">
          <div class="favorite-button-row-container">
            <button (click)="saveFilterPresetButtonClick()" class="favorite-button">
              @if (isSavedFilterPreset) {
                <mat-icon>bookmark</mat-icon>
                {{ 'UnsaveFilter' | translate }}
              } @else {
                <mat-icon>bookmark_border</mat-icon>
                {{ 'SaveFilter' | translate }}
              }
            </button>
          </div>
        </app-e-absence-conclusions-list-filters>
      }
    </div>

    <div class="content-card" [ngClass]="{ 'filters-opened': areFiltersExpanded }">
      <div #tableContainer class="wrapper custom-table">
        <cdk-virtual-scroll-viewport gridTableVirtualScroll (scrolledIndexChange)="nextBatch($event)">
          <mat-table
            class="table"
            matSort
            [matSortActive]="defaultSortColumn"
            [matSortDirection]="defaultSortDirection"
            matSortDisableClear
            [dataSource]="dataSource"
            (matSortChange)="onSortChange()"
            >
            <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  appearance="outline"
                  (change)="onSelectAllChxChange()"
                  [checked]="dataSource.selection.hasValue() && isAllSelected()"
                  [indeterminate]="dataSource.selection.hasValue() && !isAllSelected()"
                  [matTooltip]="'SelectAll' | translate"
                  matTooltipPosition="above"
                  >
                </mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="onRowChxChange($event, row)"
                  [checked]="dataSource.selection.isSelected(row)"
                  >
                </mat-checkbox>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="CompanyName">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'EAbsenceConclusionsList.CompanyName' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                ><span [matTooltip]="element.CompanyName">{{ element.CompanyName }}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="FullName">
              <mat-header-cell *matHeaderCellDef mat-sort-header="LastName" class="hidden-sort">
                {{ 'EAbsenceConclusionsList.FullName' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a
                  class="user"
                  [routerLink]="['/profile/' + element.WorkerId]"
                  [matTooltip]="'WL-ShowWokerProfile' | translate"
                  matTooltipPosition="above"
                  >{{ element.LastName + ' ' + element.FirstName }}
                </a>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="AbsenceType">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'EAbsenceConclusionsList.AbsenceType' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                ><span [matTooltip]="element.AbsenceType">{{ element.AbsenceType }}</span></mat-cell
                >
              </ng-container>

              <ng-container matColumnDef="DateRange">
                <mat-header-cell *matHeaderCellDef mat-sort-header="StartDate" class="hidden-sort">
                  {{ 'EAbsenceConclusionsList.DateRange' | translate }}
                  <app-table-header-sort></app-table-header-sort>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span [matTooltip]="(element.StartDate | date : 'yyyy-MM-dd') + ' - ' + (element.EndDate | date : 'yyyy-MM-dd')"
                    >{{ element.StartDate | date : 'yyyy-MM-dd' }} - {{ element.EndDate | date : 'yyyy-MM-dd' }}</span
                    >
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Comments">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                    {{ 'EAbsenceConclusionsList.Comments' | translate }}
                    <app-table-header-sort></app-table-header-sort>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span [matTooltip]="element.Comments">{{ element.Comments }}</span>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Status">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                    {{ 'EAbsenceConclusionsList.Status' | translate }}
                    <app-table-header-sort></app-table-header-sort>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element"
                    ><span [matTooltip]="element.Status">{{ element.Status }}</span></mat-cell
                    >
                  </ng-container>

                  <ng-container matColumnDef="Actions">
                    <mat-header-cell *matHeaderCellDef>{{ 'EAbsenceConclusionsList.Actions' | translate }}</mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <div fxLayout="row">
                        <button
                          mat-icon-button
                          (click)="onDownloadDeclarationBtnClick(element.DeclarationId, element.FileName)"
                          [matTooltip]="'EAbsenceConclusionsList.FileDownloadTooltip' | translate"
                          matTooltipPosition="above"
                          >
                          <mat-icon class="material-icons-outlined">visibility</mat-icon>
                        </button>

                        <button
                          mat-icon-button
                          (click)="onDownloadDeclarationBtnClick(element.DeclarationId, element.FileName)"
                          [matTooltip]="'EAbsenceConclusionsList.FileDownloadTooltip' | translate"
                          matTooltipPosition="above"
                          >
                          <mat-icon class="material-icons-outlined">file_download</mat-icon>
                        </button>

                        <button
                          mat-icon-button
                          (click)="onDownloadDeclarationBtnClick(element.DeclarationId, element.FileName)"
                          [matTooltip]="'EAbsenceConclusionsList.FileDownloadTooltip' | translate"
                          matTooltipPosition="above"
                          >
                          <mat-icon class="material-icons-outlined">arrow_right_alt</mat-icon>
                        </button>
                      </div>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="progress">
                    <mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length">
                      <mat-progress-bar [mode]="dataSource.isLoading ? 'indeterminate' : 'determinate'" class="table-progress" color="accent">
                      </mat-progress-bar>
                    </mat-header-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="displayedColumns; sticky: sticky" [style.top.px]="offset$ | async"></mat-header-row>
                  <mat-header-row *matHeaderRowDef="['progress']; sticky: sticky" class="progress" [style.top.px]="(offset$ | async) + 56">
                  </mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                </mat-table>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
          <app-item-counter class="item-counter" [position]="scrollItemPosition" [length]="dataSource.absoluteDataLength"></app-item-counter>
        </div>
      </div>
